package com.narbase.letsgo.web.models

import com.narbase.letsgo.dto.EnumDtoName

enum class CarCategory(override val nameAr: String,override val nameFr: String, dtoName: String? = null) : EnumDtoName {
    Sedan("سيدان", "Berline"),
    Suv("إس يو في", "SUV"),
    Hatchback("هاتشباك", "Compacte"),
    ;

    override val dtoName = dtoName ?: this.name
}